<template>
    <!-- The Modal -->
    <div class="modal" id="sendEmail">
        <!-- <div class="modal-dialog modal-dialog-centered modal-lg"> -->
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Select users and recommend <a href="">the vehicles</a></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <!-- Modal body -->

                <div class="modal-body">
                    <ul>
                        <li>From: <input type="text" name="from" id="Emailfrom" value="test@test.com" readonly /></li>
                        <li>To: <a href="#" @click="searchForPerson()">[Users]</a><input type="text" name="emailTo" id="emailTo" value="selectedEmailTo" v-model="selectedEmailTo" /></li><span class="checkbox">
                        <input type="checkbox" id="savetobookmarks" name="savetobookmarks" v-model="saveToAddressBook" />
                        <label for="savetobookmarks">Save in</label></span><a href="#" @click="openAddressBook()">[address book]</a>
                        <li>Subject: <input type="text" name="emailSubject" id="emailSubject" value="List of Cars" /></li>
                        <li>Reply To: <input type="text" name="replyTo" id="replyTo" value="" readonly /></li>
                        <li><textarea name="emailMessage" id="emailMessage" v-model="notifyMessage">{{ notifyMessage }}</textarea></li>
                    </ul>
                    <div class="row">
                        <div class="col-md-12">
                            <button name="add_to_the_email_list" id="add_to_the_email_list" @click="addToTheEmailList" class="btn" v-if="viewListOfUsers">Add to the email list</button>
                            <b-table
                                    class="list-table"
                                    :sort-by.sync="sort_by"
                                    :sort-desc.sync="sort_desc"
                                    :fields="fields"
                                    :items="users"
                                    show-empty
                                    v-if="viewListOfUsers"
                            >
                                <template v-slot:empty="scope">
                                    No user available.
                                </template>
                                <template v-slot:cell(checkbox)="data">
                                    <span class="checkbox">
                                        <input type="checkbox" name="user[]" :id="'user-'+data.item.id" :value="data.item.name+'<'+data.item.email+'>'" v-model="selectedUserEmailAccounts"/>
                                        <label :for="'user-'+data.item.id">&nbsp;</label>
                                    </span>
                                </template>
                            </b-table>

                            <button name="add_to_the_email_from_address_book" id="add_to_the_email_from_address_book" @click="addToTheEmailListFromAddressBook" class="btn" v-if="viewAddressBook">Add to the email list</button>
                            <b-table
                                    class="list-table"
                                    :sort-by.sync="sort_by"
                                    :sort-desc.sync="sort_desc"
                                    :fields="fields"
                                    :items="addressBook"
                                    show-empty
                                    v-if="viewAddressBook"
                            >
                                <template v-slot:empty="scope">
                                    No user available.
                                </template>
                                <template v-slot:cell(checkbox)="data">
                                    <span class="checkbox">
                                        <input type="checkbox" name="addressBookName[]" :id="'addressBookName-'+data.item.id" :value="data.item.name+'<'+data.item.email+'>'" v-model="addressBookName"/>
                                        <label :for="'addressBookName-'+data.item.id">&nbsp;</label>
                                    </span>
                                </template>
                            </b-table>
                        </div>
                    </div>
                    <button name="viewListOfCars" id="viewListOfCars" @click="viewSElectedCars" class="btn">View selected cars</button>

                    <div class="row">
                        <div class="col-md-12">
                            <iframe width="100%"></iframe>
                        </div>
                    </div>

                </div>
                <div class="row">
                   <div class="col-md-12">
                       <button name="sendEmail" @click="sendEmail" class="btn">Send Email</button>
                   </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>

</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../util/common'
    export default {
        props: [
            'getAllVehicles',
            'selectedVehicles',
            'cacheKey'
        ],
        created(){
            this.$store.dispatch('users/getUsers', {args: {
                    sort_by: this.sortBy,
                    sort_desc: this.sortDesc,
                }});
            this.$store.dispatch('addressBook/getAddressBook', {
                sort_by: this.sortBy,
                sort_desc: this.sortDesc,
            });
        },
        mounted(){
          //this.pushVehicleToArray()
           // this.embedHtmlToIframe()
        },
        data() {
            return {
                sort_by: 'created_at',
                sort_desc: true,
                selected_search: null,
                fields: [
                    {label: '',      key: 'checkbox'},
                    {label: 'Name',         key: 'name'},
                    {label: 'Email',        key: 'email'},
                ],
                notifyMessage: 'Hello. ' +
                'I have recommended a selection of vehicles for the upcoming auctions.\n' +
                'To view these cars, please login to the site and then click on the red link at the top of the search page.\n' +
                'http://www.sbltd-buynow.co.nz',
                selectedUserEmailAccounts: [],
                viewListOfUsers: false,
                selectedEmailTo:'',
                vehicleIds: [],
                viewAddressBook: false,
                addressBookName:[],
                viewCarList: false,
                saveToAddressBook: true
            }
        },
        computed: {
            ...mapState({
                users: state => state.users.all,
                total: state => state.users.total,
                addressBook: state => state.addressBook.all,
            }),
        },
        methods: {
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            resetRecommendedUser(){
                this.selectedUserIds = [];
            },
            searchForPerson(){
                this.viewListOfUsers = true;
                this.viewAddressBook = false;
            },
            openAddressBook(){
                this.viewAddressBook = true;
                this.viewListOfUsers = false;
            },
            addToTheEmailList(){
                this.selectedEmailTo = '';
                this.selectedEmailTo = this.selectedUserEmailAccounts
            },
            addToTheEmailListFromAddressBook(){
                this.selectedEmailTo = '';
                this.selectedEmailTo = this.addressBookName
            },
            sendEmail(){
                this.$store.dispatch('addressBook/storeRecommendation', {
                    vehicle_ids: this.selectedVehicles,
                    reply_to: '',
                    message: this.notifyMessage,
                    email_to: this.selectedEmailTo,
                    cache_key: this.cacheKey,
                    save_to_address_book: this.saveToAddressBook
                });
            },
            viewSElectedCars(){
                this.viewCarList = true
                var context = $('iframe')[0].contentWindow.document;
                var $body = $('body', context);
                $body.html(this.getAllVehicles);
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleRecommendationSendEmailModal.vue